/*
 * Copyright (c) 2024 Cozy Intellect Inc.
 */

import type { Goal, Goals } from '@repo/common';
import { debounceAsync } from '@repo/toolslib/src/utils/debounce.util';
import { uuidV4 } from '@repo/toolslib/src/utils/id.util';
import { writable } from 'svelte/store';
import { getHandler } from '../sharedlib';

export const goals = writable<Goals>({
  list: new Map<string, Goal>(),
  loaded: false,
  modalOpen: false
});

export const addGoals = (inputGoals: Partial<Goal>[]) => {
  goals.update((g) => {
    inputGoals.forEach((inputGoal) => {
      const createdDate = new Date().toISOString();
      const UID = uuidV4();
      const newGoal = {
        ...inputGoal,
        createdDate,
        UID
      } as Goal;
      g.list.set(newGoal.UID, newGoal);
    });
    return g;
  });
};

goals.subscribe(
  debounceAsync(async (g: Goals) => {
    // only save after we load, or else we would override the existing save with empty data on boot
    if (!g.loaded) return;
    console.log('Saving goals', g.list.values());
    return await getHandler().saveGoals([...g.list.values()]);
  }, 'goals.subscribe')
);

// export const augmentedGoals = derived(goals, ($t) => {
//
// });
